"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 20 20';

var ClusterMap = function ClusterMap() {
  return _react["default"].createElement("g", null, _react["default"].createElement("circle", {
    cx: "5.62211846",
    cy: "13.5555556",
    r: "1"
  }), _react["default"].createElement("circle", {
    cx: "10.427674",
    cy: "9.25",
    r: "1"
  }), _react["default"].createElement("circle", {
    cx: "6.26100735",
    cy: "9.25",
    r: "1.11111111"
  }), _react["default"].createElement("circle", {
    cx: "15.0943407",
    cy: "9.36111111",
    r: "1.08333333"
  }), _react["default"].createElement("circle", {
    cx: "10.427674",
    cy: "13.3611111",
    r: "1.77777778"
  }), _react["default"].createElement("circle", {
    cx: "15.0943407",
    cy: "13.5555556",
    r: "1"
  }), _react["default"].createElement("circle", {
    cx: "5.95545179",
    cy: "5.08333333",
    r: "1"
  }), _react["default"].createElement("circle", {
    cx: "10.7610073",
    cy: "4.88888889",
    r: "1.38888889"
  }), _react["default"].createElement("circle", {
    cx: "15.427674",
    cy: "5.08333333",
    r: "1"
  }), _react["default"].createElement("g", {
    transform: "translate(1.705452, 0)"
  }, _react["default"].createElement("path", {
    d: "M1,1 C0.785714286,0.857142857 0.571428571,0.857142857 0.357142857,1 C0.357142857,1 0.357142857,1 0.357142857,1 C0.25,1.07142857 0.178571429,1.14285714 0.107142857,1.28571429 C0.285714286,0.928571429 0.5,0.785714286 0.714285714,0.785714286 C0.821428571,0.857142857 0.928571429,0.857142857 1,1 Z"
  }), _react["default"].createElement("path", {
    d: "M1.28571429,1.28571429 C1.21428571,1.14285714 1.10714286,1.07142857 1.03571429,1 C1.03571429,1 1.03571429,1 1,1 C0.785714286,0.857142857 0.571428571,0.857142857 0.357142857,1 C0.464285714,0.857142857 0.571428571,0.857142857 0.678571429,0.857142857 C0.892857143,0.785714286 1.10714286,0.928571429 1.28571429,1.28571429 Z"
  })), _react["default"].createElement("path", {
    d: "M19.4832296,17.4722222 C19.4832296,17.6388889 19.427674,17.8055556 19.2610073,17.9722222 C19.2054518,18.0277778 19.177674,18.0555556 19.1221185,18.1111111 C18.6498962,18.5833333 18.177674,19.0555556 17.677674,19.5 C17.0387851,20.1111111 16.0665629,19.1388889 16.7054518,18.5277778 C16.8165629,18.4166667 16.9554518,18.3055556 17.0665629,18.1666667 L2.39989624,18.1666667 C2.34434068,18.1666667 2.26100735,18.1666667 2.20545179,18.1388889 C1.87211846,18.1111111 1.53878513,17.8888889 1.53878513,17.4722222 L1.53878513,2.75 C1.42767402,2.86111111 1.3165629,3 1.17767402,3.11111111 C0.566562905,3.75 -0.433437095,2.77777778 0.205451794,2.13888889 C0.705451794,1.63888889 1.20545179,1.11111111 1.67767402,0.611111111 C1.70545179,0.583333333 1.70545179,0.583333333 1.73322957,0.555555556 C1.73322957,0.555555556 1.76100735,0.527777778 1.76100735,0.527777778 C1.8165629,0.472222222 1.89989624,0.444444444 1.95545179,0.416666667 C1.95545179,0.416666667 1.95545179,0.416666667 1.95545179,0.416666667 C2.12211846,0.361111111 2.28878513,0.361111111 2.45545179,0.416666667 C2.45545179,0.416666667 2.45545179,0.416666667 2.48322957,0.416666667 C2.53878513,0.444444444 2.62211846,0.472222222 2.67767402,0.527777778 C2.67767402,0.527777778 2.70545179,0.527777778 2.70545179,0.555555556 C2.73322957,0.583333333 2.73322957,0.583333333 2.76100735,0.611111111 C3.26100735,1.11111111 3.76100735,1.61111111 4.23322957,2.13888889 C4.87211846,2.77777778 3.87211846,3.75 3.26100735,3.11111111 C3.14989624,3 3.03878513,2.86111111 2.89989624,2.75 L2.89989624,16.8055556 L17.0387851,16.8055556 L16.677674,16.4444444 C16.0387851,15.8333333 17.0110073,14.8333333 17.6498962,15.4722222 C18.1221185,15.9444444 18.5943407,16.4166667 19.0943407,16.8611111 C19.1498962,16.9166667 19.177674,16.9444444 19.2332296,17 C19.427674,17.1111111 19.5110073,17.3055556 19.4832296,17.4722222 Z"
  }));
};

var _default = (0, _createSvgIcon["default"])(ClusterMap, {
  viewBox: viewBox
});

exports["default"] = _default;